import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { config } from '../../config';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { initFacebookPixel, trackEvent } from '../../pixel';
import '../Css/Membership.css';
import Footer from '../../components/Footer';
import Navbar from '../../components/NavBar';
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';
import * as AiIcons from 'react-icons/ai';
import * as BsIcons from 'react-icons/bs';

import Bkash from '../../assets/images/Bkash.png';
import Nagad from '../../assets/images/Nagad.png';
import { PixelContext } from '../Context/PixelContext';

const apiUrl = config.apiUrl;

const Offer = () => {
  const [formData, setFormData] = useState({
    slug: '',
    tnxNumber: '',
    tnxId: '',
    tnxAmount: '',
    paymentMethod: 'bkash'
  });

  const [offer, setOffer] = useState({
    offerHeadline: 'Loading...',
    offerSubHeadline: 'Fetching details...',
    offerPrice: '',
    originalPrice: '',
    benefits: []
  });


  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [paymentSubmitted, setPaymentSubmitted] = useState(false);
  const [message, setMessage] = useState('');
  const [formError, setFormError] = useState('');

    // Get user data from localStorage
  const name = localStorage.getItem('name');
  const email = localStorage.getItem('email');
  const whatsapp = localStorage.getItem('whatsapp');

  console.log(name,email,whatsapp);

  const navigate = useNavigate();
  const { slug } = useParams();
  const pixelInitialized = useRef(false);

    const { pixel } = useContext(PixelContext);
    const pixelId = pixel?.pixel_id || null;

  const getIconComponent = (iconName) => {
    const libraries = { ...FaIcons, ...MdIcons, ...AiIcons, ...BsIcons };
    const Icon = libraries[iconName];
    return Icon ? <Icon /> : <span>✅</span>;
  };

 useEffect(() => {
  if (pixelId && !pixelInitialized.current) {
    initFacebookPixel(pixelId);
    pixelInitialized.current = true;
    
    // Standard events
    trackEvent('PageView');
    trackEvent('ViewContent', {
      content_name: offer.offerHeadline,
      content_category: 'offer_page',
      content_ids: [slug],
      value: offer.offerPrice,
      currency: 'BDT',
      email: email,
      phone: whatsapp,
      name: name,
      external_id: whatsapp
    });
    
    trackEvent('InitiateCheckout', {
      content_name: offer.offerHeadline,
      value: offer.offerPrice,
      currency: 'BDT',
      content_ids: [slug],
      email: email,
      phone: whatsapp,
      name: name,
      external_id: whatsapp
    });
  }
}, [pixel, offer, slug]);

   // Helper function to get cookies
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/offers/${slug}`);
        const offerData = response.data.offer;
        setOffer({
          offerHeadline: offerData.offerHeadline || 'Special Offer',
          offerSubHeadline: offerData.offerSubHeadline || '',
          offerPrice: offerData.offerPrice || '',
          originalPrice: offerData.originalPrice || null,
          benefits: offerData.benefits || [],
          paymentText: offerData.paymentText || '',
          paymentNumber: offerData.paymentNumber || '',
          redirect: offerData.redirect || '',
          buttonText: offerData.buttonText || 'Proceed to Payment'
        });
        setFormData(prev => ({
          ...prev,
          slug: offerData.slug,
          tnxAmount: offerData.offerPrice
        }));
      } catch (error) {
        setError("Failed to fetch offer details.");
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [apiUrl, slug]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.tnxNumber) {
      setFormError('Please input your mobile number!');
      return;
    }

    if (!paymentSubmitted) {
      setPaymentSubmitted(true);
      setFormError('');
      return;
    }

    if (!formData.tnxId) {
      setFormError('Please enter your transaction ID!');
      return;
    }

    try{
      const eventId = 'evt_' + crypto.randomUUID(); 
      
     const eventData = {
      email: email,
      phone: whatsapp,
      name: name,
      event: 'Purchase',
      content_type: 'WebinarOffer',
      content_name: offer.offerHeadline,
      content_ids: [slug],
      event_source_url: window.location.href,
      fbc: getCookie('_fbc'),
      fbp: getCookie('_fbp'),
      event_id: eventId,
      external_id: whatsapp,
      value: offer.offerPrice,
      currency: 'BDT'
    };


      trackEvent('Purchase', eventData);

      // Track server-side
      await axios.post(`${apiUrl}/fb-track`, {
        event: 'Purchase',
        ...eventData
      });
    } catch (error) {
      console.error('Facebook tracking failed:', error);
    }

    try {
      await axios.post(`${apiUrl}/webinartransactions`,formData);
      
      setMessage('Payment successful! Redirecting...');
      setFormError('');
      window.location.href = offer.redirect;
    } catch (error) {
      setFormError('Payment failed. Please try again.');
      console.error("Error creating item:", error?.response?.data?.message || error.message);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          {error}
        </div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-12 px-4 sm:px-6 lg:px-8 pt-32">
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="md:flex">
              {/* Left Side: Offer Details */}
              <div className="md:w-1/2 bg-gradient-to-br from-indigo-600 to-blue-600 p-8 md:p-12 text-white">
                <div className="mb-8">
                  <span className="inline-block px-3 py-1 text-xs font-semibold bg-white text-indigo-600 rounded-full mb-4">
                    SPECIAL OFFER
                  </span>
                  <h1 className="text-3xl md:text-4xl font-bold mb-4">{offer.offerHeadline}</h1>
                  
                  <div className="flex items-center mb-6">
                    <div className="mr-4">
                      {offer.originalPrice ? (
                        <>
                          <span className="text-4xl font-bold">৳{offer.offerPrice}</span>
                          <span className="ml-2 text-xl line-through text-indigo-200">৳{offer.originalPrice}</span>
                        </>
                      ) : (
                        <span className="text-4xl font-bold">৳{offer.offerPrice}</span>
                      )}
                    </div>
                    {offer.originalPrice && (
                      <span className="bg-yellow-400 text-yellow-900 px-3 py-1 rounded-full text-sm font-bold">
                        {Math.round(((offer.originalPrice - offer.offerPrice) / offer.originalPrice) * 100)}% OFF
                      </span>
                    )}
                  </div>
                  <p className="text-lg text-indigo-100">{offer.offerSubHeadline}</p>
                </div>

                <div className="mb-8">
                  {/* Dynamic Benefits */}
                  {offer.benefits && offer.benefits.length > 0 && (
                    <div className="mt-6 mb-4">
                      {offer.benefits.map((benefit, i) => (
                        <div key={i} className="flex items-center mb-2 font-bold">
                          <span className="mr-2">{getIconComponent(benefit.icon)}</span>
                          <span className="text-gray-50">{benefit.benefit_name}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                  <h3 className="text-xl font-semibold mb-4">পেমেন্ট করার নিয়ম</h3>
                  
                  <div className="flex space-x-4 mb-6">
                    <button 
                      onClick={() => setFormData({...formData, paymentMethod: 'bkash'})}
                      className={`px-4 py-2 rounded-lg font-medium ${formData.paymentMethod === 'bkash' ? 'bg-white text-indigo-600' : 'bg-indigo-700 text-white'}`}
                    >
                      বিকাশ
                    </button>
                    <button 
                      onClick={() => setFormData({...formData, paymentMethod: 'nagad'})}
                      className={`px-4 py-2 rounded-lg font-medium ${formData.paymentMethod === 'nagad' ? 'bg-white text-indigo-600' : 'bg-indigo-700 text-white'}`}
                    >
                      নগদ
                    </button>
                  </div>

                  {formData.paymentMethod === 'bkash' ? (
                    <div>
                      <div className="flex items-center mb-3">
                        <img src={Bkash} alt="bKash" className="h-8 mr-3" />
                        <div>
                          <p className="font-medium">বিকাশ পার্সোনাল</p>
                          <p className="text-xl font-bold">+8801635494643</p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="flex items-center mb-3">
                        <img src={Nagad} alt="Nagad" className="h-8 mr-3" />
                        <div>
                          <p className="font-medium">নগদ পার্সোনাল</p>
                          <p className="text-xl font-bold">+8801635494643</p>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="mt-6 text-sm text-indigo-100">
                    <p>১. উপরের নাম্বারে টাকা পাঠান</p>
                    <p>২. ট্রানজেকশন আইডি নিচের ফর্মে লিখুন</p>
                    <p>৩. সাবমিট বাটনে ক্লিক করুন</p>
                  </div>
                </div>
              </div>

              {/* Right Side: Payment Form */}
              <div className="md:w-1/2 p-8 md:p-12">
                <div className="max-w-md mx-auto">
                  <h2 className="text-2xl font-bold text-gray-800 mb-1">পেমেন্ট সম্পূর্ণ করুন</h2>
                  <p className="text-gray-500 mb-8">আপনার তথ্য প্রদান করুন</p>
                  
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                      <label htmlFor="tnxNumber" className="block text-sm font-medium text-gray-700 mb-1">আপনার মোবাইল নম্বর</label>
                      <input
                        type="text"
                        name="tnxNumber"
                        value={formData.tnxNumber}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                        required
                        placeholder="01XXXXXXXXX"
                      />
                    </div>

                    {paymentSubmitted && (
                      <>
                        <div>
                          <label htmlFor="tnxId" className="block text-sm font-medium text-gray-700 mb-1">ট্রানজেকশন আইডি</label>
                          <input
                            type="text"
                            name="tnxId"
                            value={formData.tnxId}
                            onChange={handleChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                            required
                            placeholder={`${formData.paymentMethod === 'bkash' ? 'bKash' : 'Nagad'} ট্রানজেকশন আইডি`}
                          />
                        </div>

                        <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
                          <p className="text-sm text-yellow-800">
                            Please send ৳{offer.offerPrice} to {formData.paymentMethod === 'bkash' ? '01635494643 (Personal)' : '01635494643 (Personal)'} and enter the transaction ID above.
                          </p>
                        </div>
                      </>
                    )}

                    <button
                      type="submit"
                      className="w-full py-3 px-6 bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 text-white font-semibold rounded-lg shadow-md transition duration-300"
                    >
                      {paymentSubmitted ? 'পেমেন্ট সাবমিট করুন' : offer.buttonText}
                    </button>

                    {paymentSubmitted && (
                      <button
                        type="button"
                        onClick={() => setPaymentSubmitted(false)}
                        className="w-full text-center text-sm text-indigo-600 hover:text-indigo-800"
                      >
                        ← তথ্য পরিবর্তন করুন
                      </button>
                    )}
                  </form>

                  {formError && (
                    <div className="mt-6 p-4 bg-red-50 border-l-4 border-red-500 text-red-700">
                      <p>{formError}</p>
                    </div>
                  )}

                  {message && (
                    <div className="mt-6 p-4 bg-green-50 border-l-4 border-green-500 text-green-700">
                      <p>{message}</p>
                    </div>
                  )}

                  <div className="mt-8 border-t pt-6">
                    <h3 className="text-sm font-medium text-gray-500 mb-3">নিরাপদ পেমেন্ট</h3>
                    <div className="flex space-x-4">
                      <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/2560px-Stripe_Logo%2C_revised_2016.svg.png" alt="Secure Payment" className="h-8 opacity-70" />
                      <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2560px-Visa_Inc._logo.svg.png" alt="Visa" className="h-8 opacity-70" />
                      <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Mastercard_2019_logo.svg/1200px-Mastercard_2019_logo.svg.png" alt="Mastercard" className="h-8 opacity-70" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Offer;